<template>
  <div>
    <b-breadcrumb class="mb-2">
      <b-breadcrumb-item :to="{name:'home'}">
        <p class="d-flex align-items-center">
          <feather-icon
            icon="HomeIcon"
            size="18"
            class="cursor-pointer"
          />
          <span style="margin-left: 0.5rem">{{ $t('navigation.home') }}</span>
        </p>
      </b-breadcrumb-item>

      <b-breadcrumb-item active>
        {{ $t('navigation.warehouse') }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <b-card
      no-body
    >
      <div class="m-2 d-flex justify-content-between">
        <h1>{{ $t('warehouses_list') }}</h1>
        <b-button
          id="buttonUpsert"
          variant="primary"
          @click="openModal"
        >
          {{ $t('add_warehouse') }}
        </b-button>
      </div>

      <b-table
        ref="refInvoiceListTable"
        responsive
        show-empty
        striped
        :busy="isLoading"
        :items="list"
        :fields="tableColumns"
        primary-key="id"
        :empty-text="$t('empty_table')"
        class="position-relative"
      >

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle" />
            <strong class="ml-1">{{ $t('loading') }}...</strong>
          </div>
        </template>

        <template #head(actions)="data">
          <div class="float-right">
            {{ $t('actions') }}
          </div>
        </template>

        <template #head(name)="data">
          <div class="float-right">
            {{ $t('title') }}
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="text-nowrap w-100 d-flex justify-content-end">
            <feather-icon
              :id="`invoice-row-${data.item.id}-send-icon`"
              icon="EditIcon"
              class="cursor-pointer mr-2"
              size="16"
              @click="update(data.item.id)"
            />

          <!--          <feather-icon-->
          <!--            :id="`invoice-row-${data.item.id}-preview-icon`"-->
          <!--            icon="DeleteIcon"-->
          <!--            size="16"-->
          <!--            class="cursor-pointer"-->
          <!--            @click="remove(data.item.id)"-->
          <!--          />-->
          </div>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              {{ $t('pagination_text', { from: paginationMeta.from, to: paginationMeta.to, of: paginationMeta.of }) }}
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="pagination.page"
              :total-rows="pagination.totalPage * pagination.perPage"
              :per-page="pagination.perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>
        </b-row>
      </div>

      <warehouse-upsert
        :id="updateId"
        :show="show"
        :method-type="methodType"
        @update:show="modalToggler"
        @update:data="findAll"
      />
    </b-card>
  </div>
</template>

<script>
import {getCurrentInstance, ref} from '@vue/composition-api'
import {
  BButton, BCard, BTable, BSpinner, BRow, BCol, BPagination, BBreadcrumbItem, BBreadcrumb,
} from 'bootstrap-vue'
import WarehouseUpsert from '@/views/warehouse/components/WarehouseUpsert.vue'

// eslint-disable-next-line import/no-cycle
import useWarehouse from '@/composables/useWarehouse'
export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BButton,
    BCard,
    BTable,
    BSpinner,
    BRow,
    BCol,
    BPagination,
    WarehouseUpsert,
  },
  setup() {
    const vm = getCurrentInstance().proxy
    const {
      list,
      region,
      tableColumns,
      isLoading,
      pagination,
      paginationMeta,
      findAll,
    } = useWarehouse()
    const show = ref(false)
    const updateId = ref(null)
    const methodType = ref('create')

    function openModal() {
      show.value = true
    }

    function update(id) {
      updateId.value = id
      methodType.value = 'update'
      openModal()
    }

    function remove(id) {
      console.log(id)
    }

    function modalToggler(mShow) {
      if (methodType.value === 'update' && !mShow) {
        updateId.value = null
      }

      show.value = mShow
    }

    findAll()

    return {
      show,
      list,
      region,
      tableColumns,
      methodType,
      updateId,
      isLoading,
      pagination,
      paginationMeta,

      openModal,
      modalToggler,
      update,
      remove,
      findAll,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
